import {NodeCreator} from './NodeCreator';



export const CreateIdea = ({ open, onClose, ws, onNodeCreated, wallType }) => {
  // 如果沒有指定 wallType，默認為 "idea"（想法牆）
  const finalWallType = wallType || "idea";

  const nodePlan = {
    title: "新增想法",
    lable: "想法標題", // 修正拼寫錯誤
    tags: "idea", // node_type 為 "idea"
    helperMsg: "請為你的想法下一個標題，讓其他同學能更快速的你的想法！",
    scaffoldBody: [
      "【💡我的想法】",
      "【🧐我覺得更好的想法】",
      "【❓我想知道】",
      "【🙅🏻這個想法不能解釋】",
      "【📄舉例和參考來源】",
      "【✍🏻我的總結】"
    ],
    scaffoldWords: ["我的想法", "我覺得更好的想法", "我想知道", "這個想法不能解釋", "舉例和參考來源", "我的總結"],
    wall_type: finalWallType // 明確設置牆面類型
  };

 return <NodeCreator open={open} onClose={onClose} ws={ws} nodePlan={nodePlan} onNodeCreated={onNodeCreated} />;
}